/** redux-persist dil anahtarı — store.js ile aynı persist key / slice adı */
const PERSIST_KEY = 'persist:globalanka-root'

/**
 * @returns {string} tr | en | ru …
 */
export function readPersistedLanguage() {
  if (typeof localStorage === 'undefined') return 'tr'
  try {
    const raw = localStorage.getItem(PERSIST_KEY)
    if (!raw) return 'tr'
    const root = JSON.parse(raw)
    const langBlock = root.language
    if (typeof langBlock !== 'string') return 'tr'
    const langState = JSON.parse(langBlock)
    const c = langState?.currentLanguage
    return typeof c === 'string' && c.trim() !== '' ? String(c).split('-')[0].toLowerCase() : 'tr'
  } catch {
    return 'tr'
  }
}
